import {useState} from 'react'
import TextArea from '@/components/Form/TextArea.jsx'
import {useReadOnly} from '@/components/Form/ReadOnly.mjs'
import SelectPcdgDfDialog from '@/pages/MainPage/dialogs/SelectPcdgDfDialog'
import {useMapContext} from '@/components/MindMap/index.mjs'

const defaultValue = {}

const SelectDgf = ({
    className,
    style,
    disabled,
    readOnly,
    value = defaultValue,
    onChange,
    ...props
}) => {
    const gReadOnly = useReadOnly()
    const map = useMapContext()
    const [visible, setVisible] = useState(false)

    const handleClickInput = () => {
        if (! readOnly || ! gReadOnly) {
            setVisible(true)
        }
    }

    const {dfUserCode = '', dfName = '', pcdgName = ''} = value ?? {}
    const text = [pcdgName, dfName, dfUserCode].join('\n')

    return (
        <div
            className={className}
            style={style}
        >
            <TextArea
                autoSize
                disabled={disabled}
                readOnly
                value={text}
                onClick={handleClickInput}
            />

            <SelectPcdgDfDialog
                style={{display: 'block'}}
                prjId={map.data.prjId}
                setVisible={setVisible}
                sVer={map.data.sVer}
                visible={visible}
                onCall={onChange}
                {...props}
            />
        </div>
    )
}

export default SelectDgf
